import {
  meSchema,
  okSchema,
  passkeyListSchema,
  type Me,
  type PasskeySummary,
} from '@map/shared';
import { api } from '../lib/api.js';

export const fetchMe = (): Promise<Me> => api.request('/auth/me', { schema: meSchema });

export const login = (password: string): Promise<Me> =>
  api.request('/auth/login', { method: 'POST', body: { password }, schema: meSchema });

export const logout = (): Promise<{ ok: true }> =>
  api.request('/auth/logout', { method: 'POST', schema: okSchema });

export const fetchPasskeys = (): Promise<{ passkeys: PasskeySummary[] }> =>
  api.request('/auth/passkeys', { schema: passkeyListSchema });
